import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Durations = React.lazy(() => import('./index'));
const DurationTable = React.lazy(() => import('./durationTable'));
const Duration = React.lazy(() => import('./duration'));
const DurationDetail = React.lazy(() => import('./durationDetail'));
const AddNewDuration = React.lazy(() => import('./addNewDuration'));
const EditDuration = React.lazy(() => import('./editDuration'));

export const useDurationRoutes = () => {

    return (
        <Route path="durations" element={<Suspense fallback={<div>منتظر باشید...</div>}><Durations /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><DurationTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewDuration/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Duration/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><DurationDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditDuration/></Suspense> } />
            </Route>
        </Route>
    )
}